import React from "react";

export default ({ fill = "#0049C6" }) => (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.28418 1.58887L9.06348 2.82031L8.0293 3.32031L7 2.60742L2.5 5.72266V13.5H11.5V10.2168H12.5V14.5H1.5V6.41504L0.78418 6.91113L0.21582 6.08887L6.71582 1.58887L7 1.3916L7.28418 1.58887Z"
            fill={fill}
        />
        <path
            d="M12 1L13.3011 3.69892L16 5L13.3011 6.30108L12 9L10.6989 6.30108L8 5L10.6989 3.69892L12 1Z"
            stroke={fill}
            strokeLinejoin="bevel"
        />
    </svg>
);
